// extracted by mini-css-extract-plugin
export default {"message-open":"Message_message-open__wsl0i","message-close":"Message_message-close__LYM6y","success-text":"Message_success-text__R7yWt","error-text":"Message_error-text__TV-eb"};